__turbopack_context__.v({
  "container": "BoxPickupUnavailableProductList-module-scss-module__M-8cPq__container",
  "productItem": "BoxPickupUnavailableProductList-module-scss-module__M-8cPq__productItem",
  "productListWrapper": "BoxPickupUnavailableProductList-module-scss-module__M-8cPq__productListWrapper",
  "title": "BoxPickupUnavailableProductList-module-scss-module__M-8cPq__title",
});
